// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  restaurantId: __t.u64().name("restaurant_id"),
  atMicros: __t.i64().name("at_micros"),
  kind: __t.string(),
  amountCents: __t.i64().name("amount_cents"),
  balanceAfterCents: __t.i64().name("balance_after_cents"),
});
